import {
  LOGIN_PAGE_FIRST_NAME,
  LOGIN_PAGE_PHONE_NUMBER,
  LOGIN_PAGE_EMAIL,
  LOGIN_PAGE_PASSWORD,
  LOGIN_PAGE_VERIFY,
  LOGIN_HIDE_MESSAGE,
  LOGIN_SHOW_LOADER,
  LOGIN_SHOW_MESSAGE,
  LOGIN_HIDE_LOADER,
  LOGIN_PAGE_CHANGE_VERIFY,
  LOGOUT_USER_RESPONSE,
  TOGGLE_HEADER,
  LOGIN_PAGE_CONFIRM_PASSWORD,
  LOGIN_PAGE_FORGOT_PASSWORD_SUCCESS,
  AUTH_SUCCESS,
  RESET_CONTINUE_BOOKING_DATA,
} from "../constants/ActionTypes";

const initialState = {
  email: "",
  password: "",
  verify: localStorage.getItem("verify"),
  user: JSON.parse(localStorage.getItem("user-data")),
  loader: false,
  alertMessage: "",
  showMessage: false,
  businessLocation: localStorage.getItem("business_location"),
  firstname: "",
  lastname: "",
  phonenumber: "",
  confirmpassword: "",
  emailsent: false,
  isSuccess: false,
  userDetail: ''
};

export default (state = initialState, { type, payload }) => {
  //
  switch (type) {
    case LOGIN_PAGE_PASSWORD:
      return { ...state, password: payload };
    case LOGIN_PAGE_CONFIRM_PASSWORD:
      return { ...state, confirmpassword: payload };
    case TOGGLE_HEADER:
      return { ...state, user: payload || JSON.parse(localStorage.getItem("user-data")) };
    case LOGIN_PAGE_EMAIL:
      return { ...state, email: payload };
    case LOGIN_PAGE_FIRST_NAME:
      return { ...state, firstname: payload };
    case LOGIN_PAGE_PHONE_NUMBER:
      return { ...state, phonenumber: payload };
    case LOGIN_PAGE_VERIFY: {
      localStorage.setItem("token", payload.jwt);
      localStorage.setItem("user-data", JSON.stringify(payload.user));
      localStorage.setItem("verify", true);
      localStorage.setItem("business_location", payload.business_location);
      return {
        ...state,
        verify: true,
        user: payload.user,
        loader: false,
        businessLocation: payload.business_location,
      };
    }
    case LOGIN_PAGE_CHANGE_VERIFY: {
      localStorage.setItem("verify", false);
      return { ...state, verify: false, isSuccess: false };
    }
    case LOGIN_SHOW_LOADER:
      return { ...state, loader: true };
    case LOGIN_HIDE_LOADER:
      return { ...state, loader: false };
    case LOGIN_SHOW_MESSAGE:
      return { ...state, showMessage: true, alertMessage: payload.message, loader: false };
    case LOGIN_HIDE_MESSAGE:
      return { ...state, showMessage: false, alertMessage: "" };
    case LOGOUT_USER_RESPONSE: {
      const isAdmin= localStorage.getItem("isAdmin");
      localStorage.clear();
      if(isAdmin == 'true') {
        localStorage.setItem("isAdmin",true);
      }
      return initialState;
    }
    case LOGIN_PAGE_FORGOT_PASSWORD_SUCCESS: {
      console.log("MEGHA", payload);
      return { ...state, emailsent: payload };
    }
    case AUTH_SUCCESS: {
      if(payload != undefined) {
        return { ...state, isSuccess: true, userDetail: payload.user };
      } else {
        return { ...state, isSuccess: true, userDetail: '' };
      }
    }
    case RESET_CONTINUE_BOOKING_DATA: {
      return { ...state, userDetail: '' };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/LoginReducer.js